import { render } from "./WeekPicks.vue?vue&type=template&id=6c056800"
import script from "./WeekPicks.vue?vue&type=script&lang=ts"
export * from "./WeekPicks.vue?vue&type=script&lang=ts"
script.render = render

export default script